import type {ReactElement} from 'react';
import React from 'react';
import type {AIImageFilters, AIImageFiltersID} from '@Panels/stock-panel/stock-panel.types';
import {SelectableAiThumbnailItem} from '@Components/selectable-ai-thumbnail-item/selectable-ai-thumbnail-item';
import styles from './ai-image-filter-pop-up.module.scss';

interface AiImageFilterPopUpProps {
  dropdownItems: AIImageFilters[];
  selectedItemID?: AIImageFiltersID;
  className?: string;
  onClick(id: AIImageFiltersID): void;
  imageClasses?: string;
}

export function AiImageFilterPopUp({...props}: AiImageFilterPopUpProps): ReactElement {
  return (
    <ul className={`${styles.container} ${props.className ?? 'flex-h-row'}`}>
      {props.dropdownItems.map((aiImageFilterItem) => {
        const isSelected = !!(props.selectedItemID && props.selectedItemID === aiImageFilterItem.id);
        return (
          <SelectableAiThumbnailItem
            key={`${aiImageFilterItem.id}`}
            isSelected={isSelected}
            id={`${aiImageFilterItem.id}`}
            onClick={() => {
              props.onClick(aiImageFilterItem.id);
            }}
            thumbnailImage={aiImageFilterItem.thumbnailImage}
            text={aiImageFilterItem.text}
            imageClasses={props.imageClasses}
          />
        );
      })}
    </ul>
  );
}
